import { POOL } from "../../pool";
import axiom from "../../utils/axiom";

const buildQueryString = (params = {}) =>
  Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");

export const uploadBulkFileApi = async ({ file, clientId, clientName, loginUserId }) => {
  const query = buildQueryString({
    clientId,
    clientName,
    loginUserId,
    fileName: file?.name,
    fileType: file?.type || file?.name?.split(".").pop(),
  });

  const response = await fetch(`${POOL.base}${POOL.paths.bulkUploadFile}?${query}`, {
    method: "POST",
    body: file,
    headers: {
      "Content-Type": file?.type || "application/octet-stream",
    },
  });

  const data = await response.json();
  if (!response.ok) {
    return [null, { response: { data } }];
  }

  return [data, null];
};

export const listBulkUploadsApi = (clientId, role, page = 0, limit = 10) =>
  axiom.get(
    `${POOL.base}${POOL.paths.listBulkUploads}?${buildQueryString({
      clientId,
      role,
      page,
      limit,
    })}`
  );

export const getBulkUploadRowsApi = (uploadId, page = 0, limit = 50) =>
  axiom.get(
    `${POOL.base}${POOL.paths.listBulkUploads}/${uploadId}/rows?${buildQueryString({
      page,
      limit,
    })}`
  );

export const startBulkUploadProcessingApi = (uploadId, loginUserId) =>
  axiom.post(`${POOL.base}${POOL.paths.listBulkUploads}/${uploadId}/process`, {
    loginUserId,
  });

export const getBulkDownloadUrl = (uploadId) =>
  `${POOL.base}${POOL.paths.listBulkUploads}/${uploadId}/download`;
